module.exports = __webpack_public_path__ + "img/nosolo-italia-praca-comercio.61443223.jpg";